module.exports = __webpack_public_path__ + "static/media/wheels-3.e39ec300.png";